import React from 'react';
import { FlowNode } from '../../../../types/flowBuilder';
import { BaseConfigProps, ConfigSection, ConfigField } from '../shared/ConfigFormHelpers';

interface StringFormatterConfigProps extends BaseConfigProps {
  node: FlowNode;
  updateConfig: (key: string, value: any) => void;
}

const StringFormatterConfig: React.FC<StringFormatterConfigProps> = ({ node, updateConfig }) => {
  return (
    <div className="space-y-4">
      <ConfigSection title="Szöveg formázás">
        <ConfigField
          label="Sablon"
          description="A formázási sablon változókkal"
        >
          <textarea
            value={node.data.config?.template || ''}
            onChange={(e) => updateConfig('template', e.target.value)}
            placeholder="Kedves {{name}}! Az összeg: {{amount}} Ft"
            rows={4}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
          />
        </ConfigField>

        <ConfigField
          label="Formázási mód"
          description="Speciális formázási opciók"
        >
          <select
            value={node.data.config?.formatMode || 'simple'}
            onChange={(e) => updateConfig('formatMode', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
          >
            <option value="simple">Egyszerű helyettesítés</option>
            <option value="html">HTML escape</option>
            <option value="url">URL encode</option>
            <option value="json">JSON escape</option>
          </select>
        </ConfigField>

        <div className="space-y-2">
          <div className="flex items-center">
            <input
              type="checkbox"
              id="trimSpaces"
              checked={node.data.config?.trimSpaces !== false}
              onChange={(e) => updateConfig('trimSpaces', e.target.checked)}
              className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
            />
            <label htmlFor="trimSpaces" className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Szóközök eltávolítása elejéről/végéről
            </label>
          </div>

          <div className="flex items-center">
            <input
              type="checkbox"
              id="removeEmptyLines"
              checked={node.data.config?.removeEmptyLines || false}
              onChange={(e) => updateConfig('removeEmptyLines', e.target.checked)}
              className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
            />
            <label htmlFor="removeEmptyLines" className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Üres sorok eltávolítása
            </label>
          </div>
        </div>
      </ConfigSection>

      <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-md p-3">
        <div className="text-xs text-yellow-700 dark:text-yellow-300">
          <strong>📝 Szöveg formázás:</strong>
          <br />• Változók: <code>{'{{variable_name}}'}</code>
          <br />• Eredmény: <code>{'{{formatted}}'}</code>
          <br />• Példa: <code>Kedves {'{{name}}'}, összeg: {'{{price}'} Ft</code>
        </div>
      </div>
    </div>
  );
};

export default StringFormatterConfig;
